<mh-wait-full #waitFull [isRoot]="true"></mh-wait-full>
<router-outlet></router-outlet>
